/** "active" → "Active". First char only; rest untouched. */
export function capitalize(value: string): string {
	return value ? value.charAt(0).toUpperCase() + value.slice(1) : value;
}

/** "san-antonio" / "new braunfels" → "San Antonio" / "New Braunfels". */
export function titleCase(value: string): string {
	return value
		.split(/[\s-]+/)
		.filter(Boolean)
		.map(capitalize)
		.join(" ");
}

/** Lowercase, strip non-alphanumerics, collapse to single hyphens. */
export function slugify(value: string): string {
	return value
		.toLowerCase()
		.trim()
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "");
}

/** Trim to `max` chars and append an ellipsis when truncated. */
export function truncate(value: string, max: number): string {
	return value.length > max ? value.slice(0, max) + "…" : value;
}

/**
 * Numeric-aware, case-insensitive sort comparator: "2.jpg" < "10.jpg", "a" == "A".
 * Locale pinned to "en" so server and browser produce the same order.
 */
export function naturalCompare(a: string, b: string): number {
	return a.localeCompare(b, "en", { numeric: true, sensitivity: "base" });
}
